var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "53px",
    viewBox: "0 0 52 53",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File---Complete",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(6.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9163975,0 C25.1954615,0 25.4499968,0.107734922 25.642123,0.284595431 L25.6812574,0.324625 L38.6410533,13.5337248 C38.8297298,13.707002 38.9584062,13.9468639 38.9913203,14.2168604 L38.9996316,14.3542012 L38.999609,20.0443244 C38.6831642,20.0149965 38.3624918,20 38.0382665,20 C37.630465,20 37.2282842,20.0237244 36.8330667,20.0698494 L36.8330193,15.4582988 L27.0831114,15.4582988 C25.3530491,15.4582988 23.9340988,14.0728526 23.8382973,12.3334687 L23.8331421,12.1457988 L23.8331421,2.20829883 L3.2499693,2.20829883 C2.69184124,2.20829883 2.23182795,2.64113216 2.17297341,3.19262194 L2.16661235,3.3125 L2.16661235,49.6875 C2.16661235,50.2543378 2.5894171,50.7249603 3.13198263,50.7851907 L3.2499693,50.7917012 L35.7496623,50.7917012 C36.3077904,50.7917012 36.7678037,50.3588678 36.8266582,49.8073781 L36.8330193,49.6875 L36.8330667,39.9301506 C37.2282842,39.9762756 37.630465,40 38.0382665,40 C38.3624918,40 38.6831642,39.9850035 38.999609,39.9556756 L38.9996316,49.6875 C38.9996316,51.4508494 37.6403387,52.8971008 35.9337896,52.9947455 L35.7496623,53 L3.2499693,53 C1.51990698,53 0.10095676,51.6145538 0.00515527363,49.8751699 L-5.68434189e-14,49.6875 L-5.68434189e-14,3.3125 C-5.68434189e-14,1.54915059 1.3592929,0.102899209 3.06584206,0.00525446314 L3.2499693,0 L24.9163975,0 Z M25.999,3.771 L25.9997544,12.1457988 C25.9997544,12.7126366 26.4225592,13.1832591 26.9651247,13.2434895 L27.0831114,13.25 L35.3,13.25 L25.999,3.771 Z",
    id: "Combined-Shape",
    fill: "#B3B3B3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(30.000000, 22.500000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Mask-Copy-2",
    fill: "#0A853D",
    cx: 7.5,
    cy: 7.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.76119403,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "6.24635976 9.41896638 11.708778 3.79663384 12.4369925 4.54616703 6.24716967 10.9171991 6.24635976 10.9163655 6.24554984 10.9171991 2.24037039 6.79476659 2.96858484 6.04523341"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileComplete);
export default __webpack_public_path__ + "static/media/File - Complete.34fb939af8dd55fbc2a321f1c90264cf.svg";
export { ForwardRef as ReactComponent };